import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import CardDemo from './CardDemo'
import CardElement from './CardElement'
import CardFormBrand from './CardFormBrand'
import { STYLE_FORM_SCHEMA } from './CardFormStyle'
import CardFormValue from './CardFormValue'
import cardIcon from './assets/card.svg'

export default genElementConfig(CONFIG_ELEMENTS.card, {
  label: t('elements.card.label'),
  icon: cardIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: CardElement,
  Demo: [CardDemo],
  FormValue: CardFormValue,
  FormBrand: CardFormBrand,
  EditorActions: EditableProMode,
})
